import React from "react";

import '../../styles/header.css'

/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo unidadHospitalaria
import { getUnidadHospitalariaName } from '../../objects/unidadHospitalaria';

/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { descrifrar } from '../../utils/functions';

/**
 * Componente que contiene los elementos relacionados al encabezado del sitio
 * @returns Component Devuelve el componente con los elementos requeridos
 */
/**
 * Componente que contiene los elmentos relacionados al encabezado del sitios
 * @param {Object} param0 Recibe los objetos necesarios para mostrar la información de sesión
 * @returns Component Devuelve el componente con los elementos requeridos
 */
const Header = ({access,nomHospital,name,uhList,userLevel}) => {
    
    /**
     * Función que atrapa el evento click de salir y dispara el cierre de sesión
     * @returns Devuelve el estado del objeto
     */
     const handleSalirClick = () => (event) => {
        event.preventDefault()
        sessionStorage.clear()
        //localStorage.clear()
        window.location.reload()
    }

    return(
        <header className='header'>
            <div className='maxwidth'>
                <div className='datosheader_2'>
                     <a href="https://auto-factura-erps.wn.r.appspot.com/">
                        <img src="https://hospitalesmac.com/img/logo.png" title="Mac Hospitales" alt="Mac Hospitales" height="45px;" className="logo"/>
                        {
                            access ? (
                                <div className='maxwidth'>
                                    <h2 className='bienvenido-salida-quirofano'>{userLevel.toString().toUpperCase()} {getUnidadHospitalariaName(descrifrar(nomHospital).toString(),uhList)}: <span className='useruh'>{descrifrar(name).toString()}</span> <span className='salir' onClick={handleSalirClick()}>Salir</span>
                                    </h2>
                                </div>
                            )
                            : null
                        }
                     </a>                        
                 </div>
            </div>
        </header>
     )
}

export default Header;